<script lang="ts">
  export let inner: HTMLButtonElement | undefined = undefined
  export let kind: 'positive' | 'negative' = 'positive'
</script>

<button on:click bind:this={inner} class={kind} {...$$props}><slot /></button>

<style>
  button {
    color: var(--tsf-white);
    padding: 1.2em;
    text-transform: uppercase;
    font-size: 0.8em;
    border-radius: 3em;
    min-width: 7em;
    cursor: pointer;
  }

  .positive {
    background-color: var(--primary);
    border-color: var(--primary);
  }

  .negative {
    background-color: var(--negative);
    border-color: var(--negative);
  }

  button.positive:disabled {
    background-color: var(--tsf-mid-blue);
    border-color: var(--tsf-mid-blue);
  }

  button.positive:active {
    background-color: var(--tsf-mid-blue);
    border-color: var(--tsf-mid-blue);
  }

  button.negative:disabled {
    background-color: var(--tsf-washed-grey);
    border-color: var(--tsf-washed-grey);
  }

  button.negative:active {
    background-color: var(--tsf-washed-grey);
    border-color: var(--tsf-washed-grey);
  }
</style>
